import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=4e0c3557&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports